import { SET_CONVERSATIONS, UPDATE_CONVERSATION } from './mutation-types'

/**
 * Query all conversations
 *
 * @param {params} id the user id
 */
export function getConversations({ commit }) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .get('/api/dispatchconversation')
      .then(response => {
        commit(SET_CONVERSATIONS, response.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * Query a specific conversation
 *
 * @param {params} id the user id
 */
export function getConversation({ commit }, params) {

  let headers = {}

  if (params.user_id !== null) {
      headers = {
        headers : {
          Impersonate: params.user_id
        }  
      }  
  }

  return new Promise((resolve, reject) => {
    this._vm.$http
      .get('/api/conversation/' + params.shipment_id, headers)
      .then(response => {
        response.data.sort(function(a, b) {
          return a.created_at - b.created_at
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

/**
 * Query all shipments of a given user
 *
 * @param {params} id the user id
 */
export function updateConversation({ commit }, params) {
  return new Promise((resolve, reject) => {    
    this._vm.$http
      .post(
        '/api/conversation/' + params.shipment_id,
        {
          message: params.message
        },
        {
          headers: { Impersonate: params.user_id }
        }
      )
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })

  commit(UPDATE_CONVERSATION, conversation)
}
